import { Component } from 'react';
import { connect } from 'unistore/react';
import { If, Then } from '@buyhatke/react-ui';

import { dashboardActions } from '@utils/store/actions';
import { getPairDetails, getCoinProperty } from '@utils/params';
import { Button } from '@components';

import BbTradeChart from './bb-trade-chart';
import BbTradeTables from './tradeTables/bb-trade-tables';
import BbControlRoom from '../bb-dashboard/bb-controlRoom';
import ErrorBoundary from '../../components/ErrorBoundary';

class BbDashboard extends Component {
	constructor(props) {
		super(props);
		const {
			coin,
			__setCurrentTradingCoin,
			__fillDoneList,
			plotData,
			shownMarket,
		} = props;

		__setCurrentTradingCoin(`${coin}${shownMarket === 1 ? '-usdt' : ''}`);
		__fillDoneList(plotData);
	}

	componentDidUpdate(prevProps) {
		const { coin, __setCurrentTradingCoin, shownMarket } = this.props;

		if (prevProps.coin !== coin || prevProps.shownMarket !== shownMarket) {
			__setCurrentTradingCoin(
				`${coin}${shownMarket === 1 ? '-usdt' : ''}`
			);
		}
	}

	render() {
		const { coin: tradeCoin, shownMarket, balanceCoins } = this.props;
		const { coin } = getPairDetails(tradeCoin);
		const coinName = getCoinProperty(coin, 'coinName');

		return (
			<div className="px-0">
				<BbControlRoom
					coin={tradeCoin}
					shownMarket={shownMarket}
					getBracketOrders={this.getBracketOrders}
					getOpenOrders={this.getOpenOrders}
					getStopLossOrders={this.getStopLossOrders}
					fetchTradeHistory={this.fetchTradeHistory}
				/>
				<h3 className="text-lg mt-8 mb-4 font-bold">
					{coinName} Price Chart
				</h3>
				<div>
					<If condition={balanceCoins.length > 0}>
						<Then>
							<ErrorBoundary>
								<BbTradeChart
									className="p-0"
									shownMarket={shownMarket}
								/>
							</ErrorBoundary>
						</Then>
					</If>
				</div>
				<ErrorBoundary>
					<BbTradeTables coinName={coinName} />
				</ErrorBoundary>
				<div className="text-center mt-4">
					<Button
						color="violet"
						href={`/trade/#/${tradeCoin.toLowerCase()}`}
						triangle="right"
						size="med"
					>
						Buy {coinName} In India
					</Button>
				</div>
			</div>
		);
	}
}

export default connect(
	'isLoggedIn, balanceCoins',
	dashboardActions
)(BbDashboard);
